import { FunctionComponent, useContext, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'

import Dropdown from 'design-system/Popovers/Dropdown'
import Body2 from 'design-system/Typography/Body/Body2'

import { CaretDown } from 'components/SVG/Caret'

import { useElement } from 'services/hooks'

import { ISort } from '../types'

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`

const SortContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

const DropdownCard = styled.div`
  width: 240px;
  padding: 4px;
  background: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.shadows.neutral.level5};
  border-radius: ${props => props.theme.radii[4]}px;
  display: flex;
  flex-direction: column;
  row-gap: ${props => props.theme.spacings[4]}px;
`

interface ISelectedProp {
  selected: boolean
}
const DropdownItem = styled.div<ISelectedProp>`
  padding: 4px;
  cursor: pointer;

  ${props =>
    props.selected
    && `
    background: ${props.theme.colors.teal50};
    color: ${props.theme.colors.blue500};
  `}

  :hover {
    background: ${props => props.theme.colors.teal50};
    color: ${props => props.theme.colors.blue500};
  }
`

const sorts: ISort[] = [
  { key: 'featured', label: 'Featured' },
  { key: 'price', label: 'Price (lowest to highest)', direction: 'ascending' },
  { key: 'price', label: 'Price (highest to lowest)', direction: 'descending' },
  { key: 'firstPublishedAt', label: 'Newest', direction: 'descending' },
  { key: 'bed', label: 'Beds ', direction: 'descending' },
  { key: 'sqft', label: 'Sqft ', direction: 'descending' },
]

interface IProps {
  sort: ISort
  setSort: (sort: ISort) => void
  sortActive: boolean
}

const ListingSortSelect: FunctionComponent<IProps> = ({ sort, setSort, sortActive }) => {
  const theme = useContext(ThemeContext)
  const [visible, setVisible] = useState(false)
  const [buttonRef, buttonElement] = useElement<HTMLDivElement>()

  return (
    <>
      <SortContainer ref={buttonRef}>
        <Body2 color={sortActive ? 'blue500' : 'neutral900'}>{sort.label}</Body2>
        <IconContainer>
          <CaretDown
            width={10}
            height={7}
            fill={theme.colors[sortActive ? 'blue500' : 'neutral900']}
          />
        </IconContainer>
      </SortContainer>
      <Dropdown
        referenceElement={buttonElement}
        visible={visible}
        setVisible={setVisible}
        yOffset={theme.spacings[4]}
        placement="bottom-end"
      >
        <DropdownCard>
          {sorts.map(sortOption => (
            <DropdownItem
              key={sortOption.label}
              selected={sortOption.key === sort.key && sortOption.direction === sort.direction}
              onClick={() => setSort(sortOption)}
            >
              {sortOption.label}
            </DropdownItem>
          ))}
        </DropdownCard>
      </Dropdown>
    </>
  )
}

export default ListingSortSelect
